import styled from "styled-components";
import General from "../../stores/GeneralStore";

const fontSize = localStorage.getItem("fontSize");

export const ComplaintContainer = styled.div`
  width: 90%;
  margin: 0 auto;
  background: ${General.contrast.contrastBackground ? General.contrast.contrastBackground : "#fff"};
  margin-bottom: 0rem;
  padding-bottom: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  * {
    color: #101e8e;
  }
`;

export const ComplaintForm = styled.div`
  padding-top: 2rem;
  display: flex;
  width: 80%;
  flex-direction: column;
  gap: 1rem;
  select {
    background: #e5eff2;
    color: #101e8e;
    opacity: 1;
    outline: none;
    width: 100%;
  }
  textarea {
    background: #e5eff2;
    color: #101e8e;
    opacity: 1;
    outline: none;
    width: 100%;
    resize: none;
    border: 1px solid #b6bfdc;
  }
`;

export const InputsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  width: 100%;
`;

export const Label = styled.label`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-weight: bolder;
  justify-content: space-around;
  width: 35%;
  font-size: calc(${fontSize} - 0.1rem);
  select {
    border: 1px solid #b6bfdc;
    padding: 1rem 0;
  }
  input {
    background: #e5eff2;
    color: #101e8e;
    opacity: 1;
    padding: 1rem 0;
    outline: none;
    border: 1px solid #b6bfdc;
    width: 100%;
  }
`;
